import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("profileUser"));

  useEffect(() => {
    if (!localStorage.getItem("profileLoggedIn")) {
      navigate("/register");
    }
  }, [navigate]);

  const handleLogout = () => {
    // Clear saved login
    localStorage.removeItem("profileUser");
    localStorage.removeItem("profileLoggedIn");

    // Redirect
    navigate("/register");
  };

  if (!user) return <h2>No user data</h2>;

  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-icon">👤</div>

        <h2>{user.name}</h2>

        <p><b>Mobile:</b> {user.mobile}</p>
        <p><b>Voter ID:</b> {user.voterId}</p>
        <p><b>Place:</b> {user.place}</p>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Logout
        </button>

      </div>
    </div>
  );
};

export default Profile;
